export interface PickupFailureReason {
    code: string;
    labelCn: string;
    labelEn: string;
    labelEs: string;
}

// 揽收失败原因
export const pickupFailureReasons: PickupFailureReason[] = [
    {code: 'ERPU001', labelCn: '地址错误', labelEn: 'Wrong Address', labelEs: 'Dirección Incorrecta'},
    {code: 'ERPU002', labelCn: '仓库关闭', labelEn: 'Warehouse Closed', labelEs: 'Almacén Cerrado'},
    {code: 'ERPU003', labelCn: '联系电话是空号', labelEn: 'Invalid Phone Number', labelEs: 'Número de Teléfono Inválido'},
    {code: 'ERPU004', labelCn: '联系不上仓库负责人', labelEn: 'Cannot Reach Contact', labelEs: 'No se Puede Contactar al Responsable'},
    {code: 'ERPU005', labelCn: '转交其他承运商', labelEn: 'Handed to Another Carrier', labelEs: 'Entregado a Otro Transportista'},
    {code: 'ERPU006', labelCn: '包裹未准备好', labelEn: 'Package Not Ready', labelEs: 'Paquete No Listo'},
    {code: 'ERPU010', labelCn: '今日无货', labelEn: 'No Package Today', labelEs: 'Sin Mercancía Hoy'}
];

// 工具函数：根据失败原因代码和语言获取显示文本
export const getPickupFailureReasonText = (reasonCode: string, language: string = 'zh-CN'): string => {
    if (!reasonCode) {
        return '';
    }
    
    // 增加西班牙语处理
    if (language.startsWith('es')) {
        const reason = pickupFailureReasons.find(reason => reason.code === reasonCode);
        return reason ? reason.labelEs : reasonCode;
    }
    
    const isEnglish = language.startsWith('en');
    const reason = pickupFailureReasons.find(reason => reason.code === reasonCode);
    return reason ? (isEnglish ? reason.labelEn : reason.labelCn) : reasonCode;
};

